export enum ModalName {
    HOW_TO_PLAY = 'HOW_TO_PLAY',
    RESULTS = 'RESULTS',
    BET_HISTORY = 'BET_HISTORY',
    LOBBY = 'LOBBY',
    SKYWARD_AUTO_PLAY = 'SKYWARD_AUTO_PLAY',
    CASINO_AUTO_PLAY = 'CASINO_AUTO_PLAY',
    CASINO_AUTO_PLAY_CONFIRM = 'CASINO_AUTO_PLAY_CONFIRM',
    TOP_SETTINGS = 'TOP_SETTINGS',
    ROULETTE_STATISTICS = 'ROULETTE_STATISTICS',
    GIZA_STATISTICS = 'GIZA_STATISTICS',
    GIZA_FAVORITES = 'GIZA_FAVORITES',
    SHOVA52_STATISTICS = 'SHOVA52_STATISTICS',
    LUCKY_KICKS_STATISTICS = 'LUCKY_KICKS_STATISTICS',
    CASINO_WELCOME = 'CASINO_WELCOME',
    DEALER_LOBBY = 'DEALER_LOBBY',
    CHAT = 'CHAT',
    RGS_SETTINGS = 'RGS_SETTINGS',
    STARZLE_SIDE_BETS = 'STARZLE_SIDE_BETS',
    STARZLE_PICK_6 = 'STARZLE_PICK_6',
    STARZLE_MORE_BETS = 'STARZLE_MORE_BETS',
    STARZLE_CHOOSE_NUMBERS = 'STARZLE_CHOOSE_NUMBERS',
    STARZLE_STATISTICS = 'STARZLE_STATISTICS',
    STARZLE_BONUS_NUMBER = 'STARZLE_BONUS_NUMBER',
    STARZLE_WELCOME = 'STARZLE_WELCOME',
    STARZLE_ACTIVE_BETS = 'STARZLE_ACTIVE_BETS',
    GAMIFICATION = 'GAMIFICATION',
    NOTIFICATIONS = 'NOTIFICATIONS',
    CONFIRM = 'CONFIRM',
    // TODO : following are Skyward related maybe rename to SKYWARD_...
    CERTIFIED_RNG = 'CERTIFIED_RNG',
    GAME_LIMITS = 'GAME_LIMITS',
    FLASH_ROULETTE_RULES = 'FLASH_ROULETTE_RULES',
    PAYOUT_TABLE = 'PAYOUT_TABLE',
    LIMITS_TABLE = 'LIMITS_TABLE',
}
